import React, { Component } from 'react';
import { Button, ButtonGroup, Col, ControlLabel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from '../../Loader';

class Create extends Component {
	render() {
		let { AppConfig, actions } = this.props;

		let {
			isLoadingAction,

			menu_form_isTierPointsEnabled,
			menu_form_isGVEnabled,
			menu_form_isCalypsoEnabled,
			menu_form_isRaffleDrawEnabled,
			menu_form_isInvitationsEnabled,
		} = AppConfig;

		let requiredSpan = <span style={{ color: 'red' }}>*</span>;

		return (
			<form>
				<Loader loading={isLoadingAction} />
				<Row>
					<Col md={6}>
						<ControlLabel>Tier Points {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<ButtonGroup>
							<Button
								bsStyle={menu_form_isTierPointsEnabled ? 'success' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isTierPointsEnabled: true,
									})
								}
							>
								Enable{menu_form_isTierPointsEnabled && 'd'}
							</Button>
							<Button
								bsStyle={!menu_form_isTierPointsEnabled ? 'danger' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isTierPointsEnabled: false,
									})
								}
							>
								Disable{!menu_form_isTierPointsEnabled && 'd'}
							</Button>
						</ButtonGroup>
					</Col>
				</Row>
				<br />
				<Row>
					<Col md={6}>
						<ControlLabel>Gift Voucher {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<ButtonGroup>
							<Button
								bsStyle={menu_form_isGVEnabled ? 'success' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isGVEnabled: true,
									})
								}
							>
								Enable{menu_form_isGVEnabled && 'd'}
							</Button>
							<Button
								bsStyle={!menu_form_isGVEnabled ? 'danger' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isGVEnabled: false,
									})
								}
							>
								Disable{!menu_form_isGVEnabled && 'd'}
							</Button>
						</ButtonGroup>
					</Col>
				</Row>
				<br />
				<Row>
					<Col md={6}>
						<ControlLabel>Calypso Voucher {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<ButtonGroup>
							<Button
								bsStyle={menu_form_isCalypsoEnabled ? 'success' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isCalypsoEnabled: true,
									})
								}
							>
								Enable{menu_form_isCalypsoEnabled && 'd'}
							</Button>
							<Button
								bsStyle={!menu_form_isCalypsoEnabled ? 'danger' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isCalypsoEnabled: false,
									})
								}
							>
								Disable{!menu_form_isCalypsoEnabled && 'd'}
							</Button>
						</ButtonGroup>
					</Col>
				</Row>
				<br />
				<Row>
					<Col md={6}>
						<ControlLabel>Raffle Draw {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<ButtonGroup>
							<Button
								bsStyle={menu_form_isRaffleDrawEnabled ? 'success' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isRaffleDrawEnabled: true,
									})
								}
							>
								Enable{menu_form_isRaffleDrawEnabled && 'd'}
							</Button>
							<Button
								bsStyle={!menu_form_isRaffleDrawEnabled ? 'danger' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isRaffleDrawEnabled: false,
									})
								}
							>
								Disable{!menu_form_isRaffleDrawEnabled && 'd'}
							</Button>
						</ButtonGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<ControlLabel>Invitations {requiredSpan}</ControlLabel>
					</Col>
					<Col md={6}>
						<ButtonGroup>
							<Button
								bsStyle={menu_form_isInvitationsEnabled ? 'success' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isInvitationsEnabled: true,
									})
								}
							>
								Enable{menu_form_isInvitationsEnabled && 'd'}
							</Button>
							<Button
								bsStyle={!menu_form_isInvitationsEnabled ? 'danger' : null}
								disabled={isLoadingAction}
								onClick={() =>
									actions.setValue({
										menu_form_isInvitationsEnabled: false,
									})
								}
							>
								Disable{!menu_form_isInvitationsEnabled && 'd'}
							</Button>
						</ButtonGroup>
					</Col>
				</Row>
			</form>
		);
	}
}

function mapStateToProps(state) {
	let { AppConfig } = state;

	return {
		AppConfig,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/AppConfig/FormContainer/MenuForm.js